import React, {ComponentProps, useRef} from "react";
import {useForm} from "./useForm";

export interface FormProps extends ComponentProps<"form"> {
  onComplete: (formData: {[key: string]: {value: string | number}}) => void;
  onFormChange?: (name: string, value: string | number) => void;
}

interface FormContext {
  formData: {
    [name: string]: {
      error?: string;
      value: string | number;
    };
  };
  setValue: (fieldName: string, value: string | number) => void;
  setError: (fieldName: string, error: string) => void;
}

export const FormCTX = React.createContext({} as FormContext);

export const Form: React.FC<FormProps> = ({
  children,
  onComplete,
  onFormChange,
  ...restProps
}) => {
  const formRef = useRef<HTMLFormElement | null>(null);
  const {formData, onSubmit, setValue, setError} = useForm(
    onComplete,
    onFormChange,
  );

  return (
    <FormCTX.Provider value={{formData, setValue, setError}}>
      <form
        ref={formRef}
        className="py-2"
        onSubmit={onSubmit}
        {...restProps}
        noValidate
      >
        {children}
      </form>
    </FormCTX.Provider>
  );
};
